import { PropTypes } from "prop-types"

const TabPanel = ({
  ariaLabel,
  children,
  name,
  value,
  ariaBusy = false,
  ariaDescribedBy = "",
  className = ""
}) => (
  <div
    role="tabpanel"
    className={`oj-tab-panel ${className}`}
    aria-busy={ariaBusy}
    aria-describedby={ariaDescribedBy}
    aria-label={ariaLabel}
    id={`${name}-${value}-panel`}
  >
    {children}
  </div>
)

TabPanel.propTypes = {
  ariaBusy: PropTypes.bool,
  ariaDescribedBy: PropTypes.string,
  ariaLabel: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired
}

export default TabPanel
